import { t } from 'i18next';
import { getRouteByPath } from '../routes/MainRoutes';

export const goodDay = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
        return t('greetings.good_morning');
    } else if (hour < 18) {
        return t('greetings.good_afternoon');
    } else {
        return t('greetings.good_night');
    }
};

const standardGreetings = (user, title = false) => {
    const greeting = goodDay();
    const userName =
        user.name && user.name.length > 0
            ? `, ${title ? user.titleShort : ''} ${user.name}`
            : '';

    return `${greeting}${userName}`;
};

export const titleHeader = (location) => {
    const title = getRouteByPath(location.pathname) || goodDay();
    const { user } = location.state || {};
    if (user?.name) {
        return `${title}: ${user?.name}`;
    }
    return title;
};
export default standardGreetings;
